import React, { ReactNode } from 'react';
import cn from 'classnames';
import Trigger, { TriggerProps } from 'rc-trigger';
import { placements } from './placements';
import './Tooltip.scss';
import overlayStyles from './Overlay.module.scss';

export type Placement = 'bottom' | 'top' | 'left' | 'right';
type TooltipWithAliases = TriggerProps & {
  overlay?: ReactNode;
  placement?: Placement;
  delay?: boolean;
};
export type TooltipProps = Omit<TooltipWithAliases, 'popupPlacement' | 'popup'>;

export function BaseOverlay({ placement = null, className = null, children }) {
  return (
    <span
      className={cn(
        className,
        overlayStyles.popover,
        placement && overlayStyles[`popover-${placement}`],
      )}
    >
      <span className={cn(overlayStyles.popoverContent, 'information-item text-small')}>
        {children}
      </span>
    </span>
  );
}

export function BaseTooltip({
  children = null,
  placement = null,
  overlay = null,
  ...props
}: TooltipProps) {
  return (
    <Trigger
      popupClassName={cn(overlayStyles.popupWrapper, props.popupClassName)}
      action={['hover']}
      destroyPopupOnHide
      popupPlacement={placement}
      builtinPlacements={placements}
      popup={overlay}
      popupAlign={{}}
      mouseEnterDelay={props.delay ? 0.3 : 0}
      popupTransitionName="rc-trigger-popup-zoom"
      {...props}
    >
      {children}
    </Trigger>
  );
}
